<template>
    <Modal width="550"
           v-model="agentFormModal"
           :title="modalTitle"
           @on-ok="ok('formValidate')"
           :loading="loading"
           @on-cancel="cancel()">
        <div class="container-recharge" style="height:450px;"  >
            <Row>
                <Col span="24" >
                    <div style="" class="form-header">
                        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="130">
                            <Form-item :label="$t('agent.username')" prop="username">
                                <label class="value-label ">
                                   {{formValidate.username}}
                                </label>
                            </Form-item>
                            <Form-item :label="$t('agent.oldPassword')" prop="oldPassword">
                                <Input type="password" v-model="formValidate.oldPassword"></Input>
                            </Form-item>
                            <Form-item :label="$t('agent.newPassword')" prop="newPassword">
                                <Input type="password" v-model="formValidate.newPassword"></Input>
                            </Form-item>
                            <Form-item :label="$t('agent.confirmPassword')" prop="confirmPassword">
                                <Input type="password" v-model="formValidate.confirmPassword"></Input>
                            </Form-item>

                        </Form>

                    </div>

                </Col>
            </Row>
        </div>
    </Modal>
</template>
<script>
    export default {
        props: ['Form'],
        data () {
            return {
                modalTitle: '',
                loading: true,
                agentFormModal: false,
                editoper: false,
                formValidate: {
                    uid:'',
                    username: '',
                    oldPassword: '',
                    newPassword: '',
                    confirmPassword: ''
                },
                ruleValidate: {
                    oldPassword: [
                        { required: true, message: this.$t('agent.oldPassword'), trigger: 'blur' }
                    ],
                    newPassword: [
                        { required: true, message: this.$t('agent.newPassword'), trigger: 'blur' }
                    ],
                    confirmPassword: [
                        { required: true, message: this.$t('agent.confirmPassword'), trigger: 'blur' }
                    ]
                },
                formDynamic: {
                    items: [
                        {
                            value: ''
                        }
                    ]
                },
            }
        },//data
        methods: {
            ok (name) {
                this.$refs[name].validate((valid) => {
                    if (!valid) {
                        this.$Message.destroy();
                        this.$Message.error(this.$t('bindAssign.dataVerifiyFail'));
                        setTimeout(() => {
                            this.loading = false;
                            this.$nextTick(() => {
                                this.loading = true;
                            });
                        }, 1000);
                    }else {
                        this.loading = false;
                        var params = new Object();
                        params.uid = this.formValidate.uid;
                        params.oldPassword = this.formValidate.oldPassword;
                        params.newPassword = this.formValidate.newPassword;
                        params.confirmPassword = this.formValidate.confirmPassword;
                        this.$store.dispatch('changePassword', params).then((res) => {
                            this.loading = false;
                            this.$Message.destroy();
                            this.$Message.success(this.$t('operationSuccess'));
                            this.agentFormModal = false;
                        }).catch(err => {
                            this.$Message.error(err.message);
                            this.agentFormModal = true;
                            setTimeout(() => {
                                this.loading = false;
                                this.$nextTick(() => {
                                    this.loading = true;
                                });
                            }, 1000);
                        });
                    }
                });

            },
            cancel () {
                this.formDynamic.items.splice('formValidate', 1);
            },
        },
        watch: {
            Form: function () {
                if (!this.agentFormModal) {
                    this.modalTitle = this.$t('agent.editPassword');
                    this.editoper = false;
                    this.$refs['formValidate'].resetFields();
                    this.agentFormModal = true;
                    this.$emit('closePasswordForm', '');
                    this.formValidate.uid = this.Form.uid;
                    this.formValidate.username = this.Form.subAccount ? this.Form.subAccount : this.Form.account;
                }
            }
        }
    }
</script>
<style lang="scss">
    .form-header {
        width: 100%;
        padding-top: 5px;
        padding-bottom: 30px;
    }
    .form-header input {
        width: 300px;
    }
    .form-header .ivu-select-selection {
        width: 300px;
    }
    .form-header .ivu-select-dropdown{
        left: 0px !important;
        width: 300px !important;
    }
</style>





// WEBPACK FOOTER //
// ChangePassword.vue?cd96d316